var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00001 8.61917C10.1029 8.61917 11.8096 6.91323 11.8096 4.80958C11.8096 2.70593 10.1029 1 8.00001 1C5.89712 1 4.19043 2.70593 4.19043 4.80958C4.19043 6.91323 5.89712 8.61917 8.00001 8.61917Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8573 16.9996V14.9044C14.8573 12.7032 11.7716 10.9043 8.00007 10.9043C4.22858 10.9043 1.14282 12.7032 1.14282 14.9044V16.9996",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIconWhite);
export default __webpack_public_path__ + "static/media/person-icon-white.6a7d18bf6a5b9fddeedf75cf2c6173e6.svg";
export { ForwardRef as ReactComponent };